// Shared guidance copy for the two payment-method removal entry points.
export const PAYMENT_METHOD_REPLACEMENT_ALERT_TITLE =
  "Keep a payment method on file";

// Phrased to cover both paths — adding a new method and reassigning an existing
// one as default — since either resolves the backend requirement.
export const PAYMENT_METHOD_REPLACEMENT_ALERT_BODY =
  "Wingspan requires a payment method on file to pay your invoices. Add a new " +
  "payment method or set an existing one as your default, then remove this one.";
